import type { CareSeekerLeadFormResponse } from "~www/types/forms/care-seeker-shallow-lead-form";
import type { LeadResponse } from "~www/types/forms/lead-response";

export type CareSeekerSubmissionResult = { firstName: string };

export type CareSeekerSubmissionResultOptions = {
  firstName: string;
  getFirstName: () => string;
};

/**
 * Derives the display result from useActionState submission state.
 * Pure: no effects, no refs. Use with useCareSeekerSubmissionTracking for analytics.
 */
export function useCareSeekerSubmissionResult(
  state: LeadResponse<CareSeekerLeadFormResponse> | null,
  options: CareSeekerSubmissionResultOptions,
): CareSeekerSubmissionResult | null {
  const { firstName, getFirstName } = options;

  if (state?.ok) {
    return {
      firstName: state.data?.isError ? getFirstName() : firstName,
    };
  }

  return null;
}
